var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoading = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8168 95.1833C49.8501 96.4851 42.6816 96.228 35.8261 94.4305C28.9706 92.6331 22.5981 89.3397 17.1665 84.7871C11.7348 80.2345 7.37869 74.5356 4.41095 68.0996C1.44322 61.6636 -0.0624823 54.6503 0.00198589 47.5634L7.50629 47.6316C7.4519 53.6106 8.72219 59.5274 11.2259 64.9571C13.7297 70.3869 17.4047 75.1948 21.9872 79.0356C26.5696 82.8764 31.9457 85.6548 37.7294 87.1713C43.5131 88.6878 49.5609 88.9047 55.4383 87.8064L56.8168 95.1833Z",
    fill: "#6241EA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading.a31f24d51febc00e7a7291585d0872ea.svg";